import { type ButtonHTMLAttributes, type ReactNode, forwardRef } from "react";

type ButtonVariant = "primary" | "secondary" | "ghost" | "danger";
type ButtonSize = "sm" | "md" | "lg";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  leadingIcon?: ReactNode;
  trailingIcon?: ReactNode;
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  { variant = "secondary", size = "md", leadingIcon, trailingIcon, className = "", children, ...rest },
  ref
) {
  const classes = ["sgs-btn", `sgs-btn--${variant}`];
  if (size !== "md") classes.push(`sgs-btn--${size}`);
  if (className) classes.push(className);

  return (
    <button ref={ref} className={classes.join(" ")} {...rest}>
      {leadingIcon}
      {children}
      {trailingIcon}
    </button>
  );
});
